module.exports = __webpack_public_path__ + "icon-roda-da-conversa.png?ed5219d5b8473b188afdea1ec80c1605";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-roda-da-conversa.png
// module id = 228
// module chunks = 0